import ChatUserProfilePicture from './ChatUserProfilePicture';

export default ChatUserProfilePicture;
